import { Button, Card, message } from 'antd';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import BinLocationService from '../../../services/Wash-service/BinLocationService';
import ResponseMessage from '../../Comman/Notification/ResponseMessge';

const OutWardConfirm = ({ userdata }) => {

    const location = useLocation();
    const navigate = useNavigate();
    const [binId, setBinId] = useState();

    useEffect(() => {
        const fetchKanbanData = async () => {
            const queryParams = new URLSearchParams(location.search);
            const bin_id = queryParams.get('binId');

            setBinId(bin_id);

            if (!bin_id) {
                ResponseMessage.error("No Bin ID provided.");
                return;
            }
        };

        fetchKanbanData();

    }, [location, userdata.su_id, navigate]);

    const handleConfirm = async () => {
        if (!binId) {
            ResponseMessage.error("No Bin ID available.");
            return;
        }

        try {
            const response = await BinLocationService.BinOutward(binId, userdata.su_id);
            console.log(response.message);

            if (response && response.data) {
            } else {
                // message.success(response.message || "No Bin data available.");
                ResponseMessage.success({ message: 'No Bin Data Available' })
                navigate("/wash/dashboard");
            }
        } catch (error) {
            console.error("Error in handleConfirm:", error);
            ResponseMessage.error(error.message || "An error occurred.");
            navigate("/wash/dashboard");
        }
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'flex-start', // Align the card towards the top
                    flexDirection: 'column',
                    height: '100vh', // Keep the vertical space in view height
                }}
            >
                <Card
                    title={
                        <div style={{ fontSize: '24px', fontWeight: 'bold', gap: '30px' }}>
                            <QuestionCircleTwoTone />  Confirm Outward!
                        </div>
                    }
                    style={{
                        width: 600,
                        boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.3)',
                        borderRadius: '10px',
                        padding: '20px',
                    }}
                >
                    <p
                        style={{
                            fontSize: '18px',
                        }}
                    >
                        Are you sure you want to confirm the outward of Bin <strong>{binId}</strong> ?

                    </p>
                    <Button
                        type="primary"
                        onClick={handleConfirm}
                        style={{
                            width: '100%',
                            marginTop: '20px', 
                            padding: '10px', 
                            fontSize: '16px', 
                        }}
                    >
                        Confirm Outward
                    </Button>
                </Card>
            </div>

        </>
    )
}

export default OutWardConfirm;
